
import React from 'react';
import { useHistory } from 'react-router';
import { useFormik } from 'formik';
import LoginPage from '../../pages/Login/Login.page';
import AuthService from '../../services/auth/auth.service';

export default function LoginContainer() {

    const history = useHistory();
    const [error, setError] = React.useState("");

    const formik = useFormik({
        initialValues: {
            email: "",
            password: ""
        },
        onSubmit: async (data) => {
            setError("");
            try {
                await AuthService.signinWithEP((data.email || "").trim(), data.password)
                history.replace("/")
            } catch (err: any) {
                setError(err?.message || "Login failed. Please check your credentials and try again.");
            }
        }
    })


    const onChange = (key: string) => (value: any) => {
        formik.setFieldValue(key, value) 
    }

    return (
        <LoginPage
            values={formik.values}
            onChange={onChange}
            onSubmit={formik.handleSubmit}
            error={error}
        />
    )
}
